import GLOBAL from "../../../global";
import axios from "../../../services/Axios";
import { PROCESS_EXERCISE_VIDEO_URL, HYBRID_EXERCISE_POST_URL } from "../MovementModal/Services/UrlManager";
import { error, success } from "../../../services/ResponseHandler";
import ErrorLogService from "../../../services/ErrorLogService";
import CONSTANT from "../../../constants/Constant";
import { getTenantFeatures } from "../../../features/tenantFeatures/useTenantFeature";

const RESPONSE_TYPE = { responseType: 'text' };

export const processExerciseVideo = async (testId, exerciseValue, isMeasurementNeeded, base64Image, exerciseTypeId, repetitionCount) => {
    const height = (GLOBAL.USER_INFO && GLOBAL.USER_INFO['Height']) || 0;

    // Robust check for Hybrid exercise (ID 5)
    // loose equality handles both string and number inputs from different parts of the app
    const isHybridExercise = exerciseTypeId == 5 || (CONSTANT.MOVEMENT_TYPES && exerciseTypeId == CONSTANT.MOVEMENT_TYPES.HYBRID);

    // Robust check for Examinetics tenant context
    const isExamineticsTenant = (GLOBAL.TENANT && GLOBAL.TENANT.toLowerCase().includes('examinetics')) ||
                                getTenantFeatures().isExamineticsEnabled;

    const isExamineticsHybrid = isHybridExercise && isExamineticsTenant;

    // console.log('--- CALISTHENICS API DEBUG ---', {
    //     tenant: GLOBAL.TENANT,
    //     exerciseValue,
    //     exerciseTypeId,
    //     repetitionCount,
    //     isHybridExercise,
    //     isExamineticsTenant,
    //     isExamineticsHybrid,
    //     targetUrl: isExamineticsHybrid ? HYBRID_EXERCISE_POST_URL : PROCESS_EXERCISE_VIDEO_URL
    // });

    let payload = {
        tenant: GLOBAL.TENANT,//ROM API
        testId: testId,
        height: height,
        exerciseName: exerciseValue,
        exerciseMode: "normal",//means not passive movement
        registeredExerciseName: exerciseValue,
        isMeasurementNeeded: isMeasurementNeeded,
        isVideoData: true,
        mediaData: base64Image,
    };

    if (isHybridExercise && (repetitionCount !== undefined && repetitionCount !== null)) {
        payload.RepetitionCount = parseInt(repetitionCount) || 0;
    }

    const currentUrl = isExamineticsHybrid ? HYBRID_EXERCISE_POST_URL : PROCESS_EXERCISE_VIDEO_URL;

    if (isExamineticsHybrid) {
        payload = {
            tenant: GLOBAL.TENANT,
            testId: testId,
            codeName: exerciseValue,
            repetitionCount: 0,
            mediaData: base64Image
        };
    }

    const errorPayload = ErrorLogService.createErrorLogPayload({
        Tenant: GLOBAL.TENANT || "Unknown_Tenant",
        Source: "processExerciseVideo",
        HelpLink: "",
        DeviceInfo: navigator.userAgent || "Unknown Device",
        RequestUrl: currentUrl,
        TestId: testId,
        IncomingData: payload
    });

    let responseObj = {
        success: false,
        message: ""
    }

    // delete payload.mediaData;

    try{
        const options = isExamineticsHybrid ? {} : RESPONSE_TYPE;
        const response = await axios.post(currentUrl, payload, options);

        // Check if response status is not 200 and log error
        if(response && response.status && response.status !== 200) {
            errorPayload.StackTrace = `HTTP ${response.status} - ${response.statusText || 'Unknown Error'}`;
            errorPayload.Message = `Video processing failed with status ${response.status}`;

            await ErrorLogService.logError(errorPayload, { fireAndForget: true });
        }

        if(response && response["success"] !== undefined){
            responseObj.success = response["success"];
            responseObj.message = response["success"] === false ? response["message"] : "";
        }
        return success(responseObj);
    }
    catch(err){
        // Log error for axios network errors or other exceptions
        errorPayload.StackTrace = err.stack || err.toString();
        errorPayload.Message = `Video processing failed: ${err.message || 'Unknown error'}`;

        await ErrorLogService.logError(errorPayload, { fireAndForget: true });

        return error(err);
    }
}